import axios from '../utils/axios'

// 会员升级
export function GetUpGradeInfo (params = {}) {
  return axios({
    url: '/Member/SApp/GetUpGradeInfo',
    method: 'get',
    params: params
  })
}
